import React, { useEffect, useState } from "react";
import "./App.css";
import AllRoutes from "./Router";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import mob_Image from "./image/mob-image.jpeg";
import { AppContext } from "./Components/utils/Appcontex";

function App() {
  const [showImage, setShowImage] = useState(false);
  const [key, setKey] = useState("ManageEmployees");
  const [activeIndex, setActiveIndex] = useState(5);
  const [open, setOpen] = useState(false);

  const extractCleanName = (url) => {
    try {
      const { hostname } = new URL(url);
      return hostname.split(":")[0].split(".")[0]; // remove port and TLDs
    } catch (e) {
      console.error("Invalid URL:", url);
      return null;
    }
  };

  // Example usage in React useEffect

  useEffect(() => {
    const currentUrl = window.location.href;
    const cleanName = extractCleanName(currentUrl);

    if (cleanName) {
      // localStorage.setItem("siteSource", cleanName);
      if (cleanName == "salarytap") {
        localStorage.setItem("selectedTab", "Salary Tap");
      } else if (cleanName == "cashontap") {
        localStorage.setItem("selectedTab", "Cashon Tap");
      } else {
      }
      console.log("Saved to localStorage:", cleanName);
    }
  }, []);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      const timer = setTimeout(() => {
        setShowImage(false);
      }, 2000);

      return () => clearTimeout(timer);
    } else {
      setShowImage(false);
    }
  }, []);

  return (
    <>
      <ToastContainer />

      {showImage ? (
        <div className="image-container">
          {/* <img src={mob_Image} alt="Mobile Image" style={{ height: "100vh" }} /> */}
        </div>
      ) : (
        <>
          <AppContext.Provider
            value={{ key, setKey, setActiveIndex, activeIndex, open, setOpen }}
          >
            <AllRoutes />
          </AppContext.Provider>
        </>
      )}
    </>
  );
}

export default App;
